//CK: 9/10/18 Based on S1 model for Domain property for Peripheral License

export class PeripheralLicenseDomains {
    constructor(data) {
        this.LicenseID = data.LicenseID ? data.LicenseID : "";
        this.CustomerID = data.CustomerID ? data.CustomerID : "";
        this.Domains = data.Domains ? data.Domains : new Array(PeripheralLicenseDomain);
        this.IsProductKey = data.IsProductKey ? data.IsProductKey : false;

    }
}

export class PeripheralLicenseDomain {

    constructor(data) {
        this.Id = data.Id || "";
        this.Name = data.Name || "";
        this.CanDelete= data.CanDelete || false;
        this.IsValid = (AllowedWildcard) => {
            //private 
            if (AllowedWildcard) {
                const REGEX_VALID_DOMAIN = new RegExp(/^(([\w-]+\.)|(\*\.))+[\w-]+$/i);
                return REGEX_VALID_DOMAIN.test(this.Name);
            } else {
                const REGEX_VALID_DOMAIN = new RegExp( /^(([a-zA-Z]|[a-zA-Z][a-zA-Z0-9\-]*[a-zA-Z0-9])\.)*([A-Za-z]|[A-Za-z][A-Za-z0-9\-]*[A-Za-z0-9])$/i);
                const REGEX_VALID_IP = new RegExp(/(25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)(\.(25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)){3}/i);
                const REGEX_VALID_IPv6 = new RegExp(/^([0-9a-fA-F]{1,4}:){7}([0-9a-fA-F]{1,4}|:)$|^([0-9a-fA-F]{1,4}:){1,7}:$|^::([0-9a-fA-F]{1,4}:){0,6}[0-9a-fA-F]{1,4}$|^[0-9a-fA-F]{1,4}:([0-9a-fA-F]{1,4}:){0,5}([0-9a-fA-F]{1,4})?$|^\[([0-9a-fA-F]{1,4}:){7}[0-9a-fA-F]{1,4}\]$/i);
                return REGEX_VALID_DOMAIN.test(this.Name) || REGEX_VALID_IP.test(this.Name) || REGEX_VALID_IPv6.test(this.Name);
            }


        };
    }
}


